import React from "react";
import { Col } from "react-bootstrap";

export default function ErrorProcessingRequest() {
  return (
    <Col className="error left-side d-flex align-items-center justify-content-center">
      <div className="text-center">
        <p>Uh oh! <br />We couldn't find any quotes matching your criteria. <br />Please check the form and try again.</p>
      </div>
    </Col>
  )
}